import { ROUTE_ACTIONS } from './constants';

export const isApplicationsAction = (action) =>
  action?.toLowerCase() === ROUTE_ACTIONS.APPLICATIONS;

export const findApplicationTypeByCode = (applicationTypes, code) => {
  if (!code) return null;

  return (applicationTypes || []).find((applicationType) => {
    const possibleCodes = [
      applicationType?.code,
      applicationType?.name,
      applicationType?.id,
      applicationType?.slug,
    ].filter(Boolean);

    return possibleCodes.some(
      (possibleCode) => String(possibleCode) === String(code)
    );
  });
};

export const normalizeLanguageForPublicTypes = (language) =>
  language === 'gr' ? 'el' : language || 'en';

export const buildApplicationsPath = (queryParams) => {
  const params = new URLSearchParams();

  if (queryParams.authority) params.set('authority', queryParams.authority);
  if (queryParams.lang) params.set('lang', queryParams.lang);
  if (queryParams.country) params.set('country', queryParams.country);
  if (queryParams.code) params.set('code', queryParams.code);
  if (queryParams.applicationsLicensePlate) {
    params.set(
      'applications_license_plate',
      queryParams.applicationsLicensePlate
    );
  }
  if (queryParams.applicationsCode) {
    params.set('applications_code', queryParams.applicationsCode);
  }

  const queryString = params.toString();
  return `/applications${queryString ? `?${queryString}` : ''}`;
};

export const buildPublicFormApplicationsPath = (queryParams) => {
  const params = new URLSearchParams();

  if (queryParams.authority) params.set('authority', queryParams.authority);
  if (queryParams.lang) params.set('lang', queryParams.lang);
  if (queryParams.country) params.set('country', queryParams.country);
  if (queryParams.code) params.set('code', queryParams.code);
  if (queryParams.applicationsLicensePlate) {
    params.set(
      'applications_license_plate',
      queryParams.applicationsLicensePlate
    );
  }
  if (queryParams.applicationsCode) {
    params.set('applications_code', queryParams.applicationsCode);
  }

  const queryString = params.toString();
  return `/public/form-applications${queryString ? `?${queryString}` : ''}`;
};

export const buildDeeplinkKey = (queryParams) =>
  [
    queryParams.action || '',
    queryParams.code || '',
    queryParams.authority || '',
    queryParams.country || '',
    queryParams.lang || '',
    queryParams.applicationsLicensePlate || '',
    queryParams.applicationsCode || '',
  ].join('|');

export const hasAnyDeeplinkParam = (queryParams) =>
  !!queryParams.action ||
  !!queryParams.code ||
  !!queryParams.authority ||
  !!queryParams.country ||
  !!queryParams.lang ||
  !!queryParams.applicationsLicensePlate ||
  !!queryParams.applicationsCode;
